import {
  Create,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';
import { MediaInput } from '../../components/inputs';

export const BrandCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="country" label="Страна" fullWidth />
      <TextInput source="description" multiline rows={4} fullWidth />
      
      <MediaInput 
        source="logoId" 
        label="Логотип бренда" 
        multiple={false}
        accept="image/*"
        helperText="Выберите логотип для бренда"
      />
    </SimpleForm>
  </Create>
);
